<template>
  <div class="flex-column width-100 align-items-center justify-content-start bg-image min-height" id="body-div" style="background-color: #f7f7f7">
    <div
      class="width-100 flex-column align-items-center justify-content-spaceBetween padding-15"
      :style="{ height: (bodyWidth * 394) / 1503 + 'px' }"
    >
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
        <div class="white fs-mid-sml">我的积分</div>
        <div class="flex-row fs-mid-sml align-items-center white justify-content-center" @click="$router.push('/prizeManagement')">
          <div style="width: 14px; height: 14px">
            <van-image :src="require('../assets/image/point_mall/list.png')" width="14px" height="14px" fit="contain" />
          </div>
          <div class="fs-mid-sml">兑换记录</div>
        </div>
      </div>
      <div class="white fs-mid-big width-100">
        {{ point }}
      </div>
    </div>
    <!-- 搜索框 -->
    <div class="padding-15 width-100 bg-white">
      <van-field
        left-icon="search"
        v-model="searchObj.name"
        style="width: 100%; background: #f7f7f7"
        placeholder="请输入商品名称"
        @keyup.enter="searchValue"
      />
    </div>
    <div class="width-100 flex-column align-items-center justify-content-start" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem">
      <div class="width-100 flex-row align-items-center justify-content-center">
        <van-dropdown-menu class="width-100">
          <van-dropdown-item @change="changeItem" v-model="searchObj.sort_type" :options="option1" />
          <van-dropdown-item @change="changeItem" v-model="value2" :options="option2" />
        </van-dropdown-menu>
      </div>
      <!-- 商品列表 -->
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="width-100 padding-lr-15">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          class="flex-row justify-content-spaceBetween align-items-center flex-wrap"
        >
          <div
            class="width-48 bg-white br-reg margin-b15 padding-15 flex-column align-items-center justify-content-center"
            v-for="(item, key) in list"
            :key="key"
            @click="$router.push({ path: '/point_mall_detail', query: { id: item.id } })"
          >
            <div class="br-reg overflow-h" :style="{ width: (bodyWidth - 30) * 0.48 - 30 + 'px', height: (bodyWidth - 30) * 0.48 - 30 + 'px' }">
              <van-image width="100%" :height="(bodyWidth - 30) * 0.48 - 30 + 'px'" :src="item.picture_url" />
            </div>
            <div class="width-100 darkgrey fs-mid-sml margin-ts canNotWrap show-line-1">
              {{ item.name }}
            </div>
            <div class="width-100 flex-row align-items-baseline justify-content-start margin-tss">
              <div style="color: #f29c33" class="fs-mid">
                {{ item.integral }}
              </div>
              <div class="fs-sml grey-999 margin-r" style="zoom: 0.83">积分</div>
              <div class="fs-sml grey-999" style="zoom: 0.83; text-decoration: line-through">￥{{ item.original_price }}</div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { get_member_info } from '@/api/home';
import { get_goods_column_lists, get_goods_lists, get_member_score } from '@/api/point_mall';
import { Toast } from 'vant';
export default {
  data() {
    return {
      list: [],
      value2: 0,
      option1: [
        { text: '综合排序', value: 1 },
        { text: '积分降序', value: 2 },
        { text: '积分升序', value: 3 }
      ],
      option2: [{ value: 0, text: '全部' }],
      loading: false,
      finished: true,
      refreshing: false,
      bodyWidth: 0,
      bodyHeight: 0,
      point: 0,
      searchObj: {
        pageNum: 0,
        pageSize: 10,
        sort_type: 1,
        name: ''
      },
      showEmpty: false
    };
  },
  created() {
    document.title = '今日独家福利';
  },
  async beforeMount() {
    await get_member_info()
      .then((res) => {
        if (res.code == 0) {
          this.userInfo = res.data;
          this.$store.commit('setUserInfo', { ...res.data });
        } else {
          this.$router.replace({ path: '/login', query: { path: 'point_mall' } });
        }
      })
      .catch((err) => console.log(err));
    this.$nextTick(() => {
      this.bodyWidth = document.getElementById('body-div').clientWidth;
      this.bodyHeight = document.documentElement.clientHeight;
    });
    await get_goods_column_lists().then((res) => {
      if (res.code == 0) {
        if (res.data.length != 0) {
          this.option2 = this.option2.concat(
            res.data.map((item) => {
              item.text = item.name;
              item.value = item.id;
              return item;
            })
          );
        }
      }
    });
    // eslint-disable-next-line no-undef
    CP.getUniqueId({
      completed: (data) => {
        console.log(data);
        get_member_score({ session_id: data.unique_id }).then((res) => {
          if (res.code == 0) {
            this.point = res.data;
          } else {
            console.log(res.msg);
          }
        });
      },
      cpIncompatible: () => {
        Toast('此环境不支持此方法');
      }
    });
    this.onLoad();
  },
  methods: {
    onRefresh() {
      this.refreshing = false;
      this.loading = true;
      this.finished = false;
      this.showEmpty = false;
      this.list = [];
      this.searchObj.pageNum = 0;
      this.onLoad();
    },
    onLoad() {
      this.searchObj.pageNum += 1;
      this.getList();
    },
    async getList() {
      await get_goods_lists({
        page: this.searchObj.pageNum,
        column_id: this.value2,
        sort_type: this.searchObj.sort_type,
        name: this.searchObj.name
      }).then((res) => {
        if (res.code == 0) {
          this.list = this.list.concat(res.data);
          if (res.data.length == 0) {
            this.finished = true;
          }
          if (this.searchObj.pageNum == 1 && res.data.length == 0) {
            this.showEmpty = true;
          }
        }
        console.log(res);
      });
      this.loading = false;
    },
    searchValue() {
      this.onRefresh();
    },
    changeItem() {
      this.onRefresh();
    }
  }
};
</script>

<style scoped>
#body-div {
  background-image: url('../assets/image/point_mall/bg-image.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
::v-deep .van-list__loading {
  width: 100%;
}
::v-deep .van-list__finished-text {
  width: 100%;
}
::v-deep .van-dropdown-menu__bar {
  background: none;
  box-shadow: none;
}
::v-deep .van-ellipsis {
  color: #999;
}
</style>